import React from 'react'
import { Glyphicon, PageHeader } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import SupplierEditor from './SupplierEditor.jsx'
import { updateSupplier } from '../ducks/suppliers'
import { docPageStyle } from '../containers/PageStyles'
import { getSupplierForUrl, getReadyState, getFromQuery } from '../selectors'
import { getText } from '../lib/text.js'

/** Page
 *
 */

type Props = {
  ready: boolean,
  supplier: Object,
  routeParams: {id: string},
  onChange: (string, Object) => void
}

class Supplier extends React.PureComponent
{
  props:Props

  render() {
    const { ready, supplier, routeParams, onChange } = this.props
    const { id } = routeParams
    const s = supplier

    if (!ready || !s) return <p>Loading...</p>

    return (
      <div style={docPageStyle({maxWidth: 750})}>
        <Link to={this.props.backLink} style={{fontWeight: "bold", fontSize: "15px"}}>
          { "< " + getText("Volver a la lista")}
        </Link>
        <PageHeader style={{ position: "sticky", top: 0, backgroundColor: "white" }}>
          {s.name}
          <Link to={`/private/log/suppliers/${id}`} style={{ fontSize: "0.8em", marginLeft: 20 }}>
            <Glyphicon glyph="list" /> Ver log
          </Link>
        </PageHeader>
        <SupplierEditor
          supplier={s}
          onChange={changes => onChange(id, changes)}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ready: getReadyState(state, props),
  supplier: getSupplierForUrl(state, props),
  backLink: getFromQuery(state, props)("back") || "/private/suppliers",
})

const mapDispatchToProps = dispatch => ({
  onChange: (id, changes) => dispatch(updateSupplier(id, changes))
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(Supplier)
